import { InviteeFileReference } from 'server/shared/models/invitee';
import { InviteeFile } from 'server/shared/models/inviteeFile';
import { UploadFile } from 'server/shared/models/userCustomerInformation';
import { getApiURL } from '../environments/getApiURL';

export const downloadFile = async (
  file: UploadFile | InviteeFile | InviteeFileReference,
  userId: string,
  onProgress?: (percentage: number) => void,
) => {
  const fileId = 'id' in file ? file.id : file._id;
  const url = new URL(getApiURL() + '/getfile');
  url.searchParams.append('id', fileId);
  url.searchParams.append('userId', userId);

  let loaded = 0;
  let total = parseInt(file.size);

  await fetch(encodeURI(url.href), {
    method: 'POST',
    headers: {
      accept: 'application/json',
    },
  })
    // Retrieve its body as ReadableStream
    .then((response) => {
      if (!response || !response.body) {
        return;
      }
      const reader = response.body.getReader();
      return new ReadableStream({
        start(controller) {
          return pump();

          function pump(): any {
            return reader.read().then(({ done, value }) => {
              // When no more data needs to be consumed, close the stream
              if (done || !value) {
                controller.close();
                return;
              }

              // Enqueue the next data chunk into our target stream
              loaded += value.byteLength;
              if (onProgress) {
                onProgress(Math.round((loaded / total) * 100));
              }
              controller.enqueue(value);
              return pump();
            });
          }
        },
      });
    }) // Create a new response out of the stream
    .then((stream) => new Response(stream))
    .then((response) => response.blob())
    .then(async (blob) => {
      //if blob is a file then size is larger than 300 bytes else it an error message
      const isRealisticBlobSize = blob.size > 300;
      if (!isRealisticBlobSize) {
        const blobText = await blob.text();
        throw Error(blobText.replace('error: ', ''));
      }
      return blob;
    })
    .then((blob) => {
      const downloadedFile = new File([blob], file.fileName);
      let a = document.createElement('a');
      const url = URL.createObjectURL(downloadedFile);
      a.href = url;
      a.download = file.fileName;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
};
